// extracted by mini-css-extract-plugin
export default {"body":"nav_body__hmIZ3","head":"nav_head__3bRqX","logo":"nav_logo__-yTPJ","label":"nav_label__lesyC","links":"nav_links__hX241","current":"nav_current__x7Cn8"};